// extracted by mini-css-extract-plugin
module.exports = {"container":"App-module__container__1cmbGug_"};